export default "__VITE_ASSET__BvIqiGhB__"